module.exports = __webpack_public_path__ + "static/mobile-paprika-fe4d9fdf5c1a6ad742f1dd140d80787e.png";